import {ListItemButton, ListItemText} from '@mui/material';
import styled from 'styled-components';
import {ItemType, TitleType} from './types';

export const Item = styled(ListItemButton)<ItemType>`
  padding-left: 8px;
  padding-right: 8px;
  font-weight: 500;
  border-radius: 8px;
  box-sizing: border-box;
  width: 100%;

  span {
    color: #757C8B;
    padding-left: 12px !important;
  }

  svg {
    color: ${(props) => props.theme.sidebar.svgColor};
    font-size: 24px;
    min-width: 20px !important;
    width: 20px !important;
    height: 20px !important;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.hover};

    svg {
      color: ${(props) => props.theme.sidebar.svgColorActive};
    }

    span {
      color: ${(props) => props.theme.sidebar.text.color};
    }
  }

  &.active {
    background-color: ${(props) => props.theme.sidebar.activeClass};

    svg {
      color: ${(props) => props.theme.sidebar.svgColorActive};
    }

    span {
      color: ${(props) => props.theme.sidebar.text.color};
      font-size: 14px;
      padding-right: 8px;
    }

    &:before {
      content: '';
      height: 20px;
      width: 4px;
      opacity: 1;
      border-bottom-right-radius: 8px;
      border-top-right-radius: 8px;
      background: #3B82F6;
      position: absolute;
      top: 50%;
      left: -24px;
      transform: translateY(-50%);
    }
  }
`;

export const Title = styled(ListItemText)<TitleType>`
  margin: 0;

  span {
    color: #757C8B;
    font-weight: 600;
    line-height: 20px;
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
    padding: 0 0 0 24px;
    max-width: 160px;
    text-transform: capitalize;
    white-space: nowrap;
  }
`;
